<template>
    <div>
        <h4 class="short">Date: {{ value }}</h4>
        <vue-slider class="big-space"
            v-model="value"
            v-bind="options" 
        ></vue-slider>
    </div>
</template>

<script lang="ts">
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'

export default {
    name: 'DateSelector',
    components: {
        VueSlider
    },
    props: {
        sources: Array,
        date: String
    },
    data() {
        var startDate = new Date();
        return {
            value: "",
            options: {
                selectedDate: "",
                data: [],
                marks: [],
                contained: true
            },
            year: startDate.getFullYear(),
            month: startDate.getMonth(),
            day: startDate.getDate()
        }
    },
    methods: {
        makeDateRange() {
            var dates = new Set();
            this.sources.forEach(source => {
                source.measurements.forEach(meas => {
                    // console.log("Adding date: ");
                    // console.log(meas.dateMeasured);
                    dates.add(new Date(meas.dateMeasured));
                });
            });

            // convert to sorted array
            var dataDates = Array.from(dates);
            console.log("made array")
            dataDates.sort(this.sortAscendingDates);
            console.log("sorted array")

            console.log("assigned data")
            // only add labels if there are fewer than 8
            var viewDates = this.makeLabelsFromDates(dataDates);

            console.log(viewDates);

            this.options['data'] = viewDates;

            var labelDates = viewDates;
            if (labelDates.length > 7) {
                labelDates = [labelDates[0], labelDates[labelDates.length - 1]]
                console.log("short labels");
                console.log(labelDates);
            }

            this.options['marks'] = labelDates;
            // this.options['dataLabel'] = labelDates;
            // this.options['dataValue'] = labelDates;
            this.value = this.options.data[0]
        },
        updateDate() {
            var date = new Date();
            this.selectedDate = date;
            this.year = date.getFullYear(),
            this.month = date.getMonth(),
            this.day = date.getDate()
        },
        getDateFromValue(value) {
            return new Date(value);
        },
        makeLabelsFromDates(dates) {
            var labels = []
            dates.forEach(date => {
                labels.push(this.makeLabelFromDate(date))
            });

            console.log("made labels")
            // if there are too many dates, just pick some
            return labels;
        },
        makeLabelFromDate(date) {
            return date.toLocaleDateString();
        },
        sortAscendingDates(date1, date2) {
            if (date1 > date2) return 1;
            if (date1 < date2) return -1;
            return 0;
        }
    },
    watch: {
        value: function() {
            this.selectedDate = new Date(this.value);
            this.$emit('setSelectedDate', this.selectedDate);
        },
        sources: function() {
            this.makeDateRange()
        }
    }
};
</script>

<style lang="scss" scoped>
$blue: #0079c1;
$gray: #959595;
$white: #fff;

header {
    background-color: $blue;
    color: $white;
    width: 100%;
    height: 2rem;
    line-height: 2rem;
    position: relative;
    font-weight: 400;
    font-style: normal;
    border-bottom: 1px solid $gray;
    text-align: center;
    span {
        vertical-align: middle;
    }
}

// .short {
//     margin: 10px 10px;
// }

.big-space {
    padding: 10px 40px 20px;
}

</style>
